export function getSpaceRoles(state = [], action) {
  switch (action.type) {
    case "GET_SPACE_ROLES":
      return action.data;
    default:
      return state;
  }
}
